// extracted by mini-css-extract-plugin
export default {"layout":"main-layout_layout__abRZv","info":"main-layout_info__CT8cj"};